import script from "./ResourceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__